import { ReactNode } from "react";

import { useWorkspaceController } from "./controllers/useWorkspaceController";

export interface WorkspaceWrapperModel {
  children: ReactNode;
}

/**
 * Workspace shell wrapper — delegates all state management, side-effects,
 * and store interactions to {@link useWorkspaceController}.
 *
 * This component is intentionally a thin view with no internal state.
 */
export default function WorkspaceWrapper({
  children
}: WorkspaceWrapperModel): JSX.Element {
  useWorkspaceController();

  return <>{children}</>;
}
